import { createClient } from '@supabase/supabase-js'

// Supabase 設定 - 使用環境變數或硬編碼值
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://ktqwxutgkbnygnzwqwar.supabase.co'
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt0cXd4dXRna2JueWduendxd2FyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjIwNjY2NjMsImV4cCI6MjA3NzY0MjY2M30.DoSXW2lByHYcf9WHszh2WOv1IVjDMYuQkM_ROW05cb4'

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.error('❌ Supabase 環境變數缺失')
  throw new Error('Missing Supabase environment variables')
}

// 創建 Supabase 客戶端
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  },
  global: {
    headers: {
      'X-Client-Info': 'petcare-app@1.0.0'
    }
  }
})

// 🚀 優化：延遲測試連接（非阻塞，在背景執行）
if (import.meta.env.DEV) {
  // 只在開發環境執行，延遲 2 秒避免阻塞初始化
  setTimeout(async () => {
    try {
      console.log('🔍 [Supabase] 背景測試連接...');
      const { data, error } = await supabase.from('pets').select('count').limit(1);
      
      if (error) {
        if (error.message.includes('relation "pets" does not exist')) {
          console.log('⚠️ [Supabase] pets 資料表不存在，但連接正常');
        } else {
          console.error('❌ [Supabase] 連接失敗:', error.message);
        }
      } else {
        console.log('✅ [Supabase] 連接和資料表都正常');
      }
    } catch (err) {
      console.error('❌ [Supabase] 連接測試發生錯誤:', err.message);
    }
  }, 2000); // 延遲 2 秒
}

// 導出配置供其他模組使用
export const SUPABASE_URL_EXPORT = SUPABASE_URL
export const SUPABASE_ANON_KEY_EXPORT = SUPABASE_ANON_KEY

export default supabase